import { Button } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Card, Col, Row } from 'reactstrap';

import { PathsLayouts } from '../../../config/routes';
import { ContinuousEducationSectionsFiltersFormLoader } from './hooks/ContinuousEducationSectionsFiltersFormLoader';
import { ContinuousEducationSectionsLoader } from './hooks/ContinuousEducationSectionsLoader';
import SectionsSearch from './parts/SectionsSearch';
import SectionsTable from './parts/SectionsTable';

const Sections = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Card className="p-4 mt-2 mx-3">
      <ContinuousEducationSectionsFiltersFormLoader fetchImmediately>
        <ContinuousEducationSectionsLoader
          defaultQuery={{ page: 1, items_per_page: 10 }}
          fetchImmediately
        >
          <Row>
            <Col xs={12}>
              <p>Lorem ipsum...</p>
            </Col>
            <Col xs={12}>
              <SectionsSearch />
            </Col>
            <Col xs={12} className="mb-4 text-right">
              <Button
                icon="plus"
                onClick={() =>
                  history.push(
                    `${PathsLayouts.continuousEducation}/sections/create`,
                  )
                }
                outlined
                size="md"
                text={t('sectionsMaintainer.list.createSection')}
              />
            </Col>
            <Col xs={12}>
              <SectionsTable />
            </Col>
          </Row>
        </ContinuousEducationSectionsLoader>
      </ContinuousEducationSectionsFiltersFormLoader>
    </Card>
  );
};
export default Sections;
